import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { LoaderState } from '../models/loader.model';

@Injectable()
export class LoaderService {
  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();
  constructor() { }

  startLoading() {
    this.loaderSubject.next(<LoaderState>{show: true});
  }

  stopLoading() {
    this.loaderSubject.next(<LoaderState>{show: false});
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/loader.service.ts